import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-main',
  templateUrl: './loader-main.component.html',
  styleUrls: ['./loader-main.component.scss']
})
export class LoaderMainComponent {

}
